import { ERROR } from "constant/message";
import { MONTH_NAMES } from "constant";

const dateFormat = (date) => {
  try {
    // eslint-disable-next-line prettier/prettier
    const dateF = ` ${String(date.getDate()).padStart(2, "0")}/${
      MONTH_NAMES[date.getMonth()]
      // eslint-disable-next-line prettier/prettier
    }/${date.getFullYear()}`;
    return dateF;
  } catch (error) {
    console.log("dateFormat eror", error);
    return ERROR;
  }
};
export default dateFormat;
export const formatDateYMD = (date) => {
  return date ? new Date(date).toISOString().split("T")[0] : ""; // Format YYYY-MM-DD
};

/* export const calculateAge = (dateOfBirth) => {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();

  // Adjust if the current month is before the birth month
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  return { years, months };
}; */

export const calculateAge = (dateOfBirth, dateOfDeath) => {
  let limitDate = new Date();
  if (dateOfDeath) {
    limitDate = new Date(dateOfDeath);
  }
  const birthDate = new Date(dateOfBirth);

  let years = limitDate.getFullYear() - birthDate.getFullYear();
  let months = limitDate.getMonth() - birthDate.getMonth();
  let days = limitDate.getDate() - birthDate.getDate();

  if (days < 0) {
    months -= 1;

    const previousMonth = new Date(limitDate.getFullYear(), limitDate.getMonth(), 0).getDate();

    days += previousMonth;
  }

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  return { years, months, days };
};

export const dateFormatFull = (date) => {
  try {
    const dateF = ` ${String(date.getDate()).padStart(2, "0")}/${
      MONTH_NAMES[date.getMonth()]
    }/${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;

    return dateF;
  } catch (error) {
    console.log("dateFormat error", error);
    return ERROR;
  }
};
